module.exports = __webpack_public_path__ + "static/cashew_nuts_vuon_4-a9b3cc716b102b34d406a3638d6d5633.jpg";